import React from "react";
import { createRoot, RootType } from "react-dom/client";
import { App } from "../components/Srt/App";
import { SocketProvider, AppProvider } from "../components/Srt/providers";
import * as T from "../components/Srt/types";

export interface IConveySrtOpts {
  $container: string;
  accessToken: string;
  darkMode?: boolean;
  onTranscript?: (transcript: T.TranscriptionWSResponse) => void;
  onReady?: (config: T.AppConfig) => void;
}

export class ConveySrt implements IConveySrtOpts {
  $container: string;
  $element: HTMLElement;
  accessToken: string;
  darkMode?: boolean;
  root?: RootType;
  mounted: boolean;
  socket: WebSocket;
  onTranscript?: (transcript: T.TranscriptionWSResponse) => void;
  onReady?: (config: T.AppConfig) => void;

  constructor(params: IConveySrtOpts) {
    const $container = document.getElementById(params.$container);
    this.mounted = false;

    if ($container) {
      this.$element = $container;
      this.$container = params.$container;
      this.accessToken = params.accessToken;
      this.darkMode = params.darkMode || false;
      this.onTranscript = params.onTranscript;
      this.onReady = params.onReady;
      this.socket = null;
      this.initRoom();
    } else {
      console.error(`ConveySrt: #${params.$container} not found.`);
    }

    return this;
  }

  initRoom() {
    if (!this.root) {
      this.root = createRoot(this.$element);
    }
    this.mounted = true;

    this.root.render(
      <AppProvider accessToken={this.accessToken} initialDarkMode={this.darkMode}>
        <SocketProvider
          onTranscript={this.onTranscript}
          ref={(socketRef) => {
            this.socket = socketRef;
          }}
        >
          <App onReady={this.onReady} />
        </SocketProvider>
      </AppProvider>
    );
  }

  destroy() {
    if (this.socket) {
      this.socket.close();
      this.socket = null;
    }
    if (this.root) {
      this.root.unmount();
      this.root = null;
      this.mounted = false;
    }
    this.$element = null;
    this.$container = null;
    this.accessToken = null;
    this.darkMode = false;
    this.onTranscript = null;
    this.onReady = null;
  }
}
